import apiClient from "./apiClient";

/**
 * Fetches the latest public policy definition.
 * The backend is the canonical source-of-truth.
 *
 * @returns {Promise<object>} Parsed response body
 */
const fetchPublicPolicy = async () => {
  const response = await apiClient.get("/public/policy");
  return response.data;
};

export { fetchPublicPolicy };
